export enum BridgeLocation {
  None = "",
  BSC = "BNB Chain",
  Game = "Game",
  ETH = "ETH",
}
